exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected[data-v-3707d0e4] {\n  background-color: #cceaed;\n}\n", ""]);

// exports
